/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import shenzhen from "./assets/img/shenzhen.png";
import chongqing from "./assets/img/chongqing.png";
import beijing from "./assets/img/beijing.png";
import guilin from "./assets/img/guilin.png";
import xian from "./assets/img/xian.png";
import suzhou from "./assets/img/suzhou.png";
import xiamen from "./assets/img/xiamen.png";
import changsha from "./assets/img/changsha.png";
import airport from "./assets/img/airport.png";
import chenChenTemple from "./assets/img/chen-chen-temple.png";
import lianhuashanPark from "./assets/img/lianhuashan-park.png";
import zhuhaiOceanKingdom from "./assets/img/zhuhai-ocean-kingdom.png";
import zhuhai from "./assets/img/zhuhai.png";
import returnTrip from "./assets/img/return.png";
import juzizhoutou from "./assets/img/juzizhoutou.png";
import shaoshan from "./assets/img/shaoshan.png";
import hunanU from "./assets/img/hunan-university.png";
import huanglongcave from "./assets/img/huanglongcave.png";
import zhangjiajie2 from "./assets/img/zhangjiajie2.png";
import jimeiU from "./assets/img/jimeiU.png";
import gulangyu from "./assets/img/gulangyu.png";
import quanzhouwulin from "./assets/img/quanzhouwulin.png";
import xiamenU from "./assets/img/xiamenU.png";
import wuzhen from "./assets/img/wuzhen.png";
import hangzhou from "./assets/img/hangzhou.png";
import nanjing from "./assets/img/nanjing.png";
import suzhouCity from "./assets/img/suzhou-city.png";
import shanghai2 from "./assets/img/shanghai2.png";
import qinglongsi from "./assets/img/qinglongsi.png";
import qinshihuang from "./assets/img/qinshihuang.png";
import huashan from "./assets/img/huashan.png";
import luoyang from "./assets/img/luoyang.png";
import shaolin from "./assets/img/shaolin.png";
import daxing from "./assets/img/daxing.png";
import tianjin from "./assets/img/tianjin.png";
import daqiuzhuang from "./assets/img/daqiuzhuang.png";
import gongwangfu from "./assets/img/gongwangfu.png";
import greatwall from "./assets/img/greatwall.png";
import tiananmen from "./assets/img/tiananmen.png";
import jingjiang from "./assets/img/jingjiang.png";
import liusanjie from "./assets/img/liusanjie.png";
import longji from "./assets/img/longji.png";
import gudong from "./assets/img/gudong.png";
import wulong from "./assets/img/wulong.png";
import difeng from "./assets/img/difeng.png";
import chongqingtrain from "./assets/img/chongqingtrain.png";
import dujiangyan from "./assets/img/dujiangyan.png";
import panda from "./assets/img/panda-nail.png";

export const tourRouts = {
  shenzhen: {
    headerImg: shenzhen,
    headerLine: "Guangzhou, Shenzhe, Zhuhai for 6 days",
    days: [
      {
        subHeader: "DAY 1",
        header: "Bulgaria - Guangzhou/Shenzhen",
        img: airport,
        description:
          "Gathering: gather in Bulgaria, take the plane to Guangzhou / Shenzhen, the tour guide after the Jiangnan tour. Professional airport personnel to the hotel. After checking in the hotel, tourists can choose to visit the Chengdu business circle pedestrian street or web celebrity scenic spots. During the free activities, please pay attention to the safety of personal property and property!",
      },
      {
        subHeader: "Guangzhou",
        header: "Chen Chen Temple-Huacheng Square",
        img: chenChenTemple,
        description:
          "At 09:30, go to Chen Chen Temple, listen to the guide&apos;s explanation, understand the exquisite decoration technology of &apos;three sculptures and two sculptures&apos; in Lingnan architecture, and feel the brilliant beauty of this book as the pearl of Lingnan architectural art.",
      },
      {
        subHeader: "Shenzhen",
        header: "Lianhuashan Park, Shenzhen Citizen Park, Damisha",
        img: lianhuashanPark,
        description:
          "After 09:30, go to Shenzhen Lianhuashan Park, the &apos;green lung&apos; of Shenzhen. Climbing to the top of Lianhua Mountain can overlook the panoramic view of Shenzhen city. In particular, the statue of Deng Xiaoping in the park is also one of the landmarks of Shenzhen.",
      },
      {
        subHeader: "Zhuhai",
        header: "Shenzhen-China Channel, Ocean Kingdom, fireworks show in the evening",
        img: zhuhaiOceanKingdom,
        description:
          "we will leave for Zhuhai Ocean Kingdom, passing through the deep-middle passage. The overall design of the deep-middle passage is inspired by the elegant / elegant kite. A tunnel is like a line sometimes absent when a kite is flying, facing the place where the sun rises in the east, symbolizing the pursuit of excellence, excellence and the realization of the Chinese dream. The east artificial island is like the wire tray of a kite, and the bridge is like the elegant tail of a kite, closely tying the two sides of the Pearl River Estuary, forming the overall aesthetic theme of &apos;kite matchmaking&apos;.",
      },
      {
        subHeader: "Zhuhai",
        header: "Zhuhai city meeting room-Sun Yuebei-fishing girl",
        img: zhuhai,
        description:
          "The Zhuhai city meeting room is a public space set up by the Zhuhai municipal government to enhance the city&apos;s image and promote civic exchanges. Its main function is to provide a place for culture, art and leisure, and also to undertake the task of displaying Zhuhai&apos;s urban characteristics and development achievements.",
      },
      {
        subHeader: "Return Trip",
        header: "Zhuhai Airport",
        img: returnTrip,
        description: "Go to the station according to the flight time, the trip is successfully concluded!",
      },
    ],
  },
  chongqing: {
    headerImg: chongqing,
    headerLine: "Chongqing + Chengdu custom-pure play 7-day tour",
    days: [
      {
        subHeader: "DAY 1",
        header: "Chengdu",
        img: airport,
        description:
          "Tourists will fly to Chengdu according to the flight time, and professional airport pickup personnel will pick them up to the hotel. After checking in the hotel, tourists can choose to visit the Chengdu business circle pedestrian street or web celebrity scenic spots. During the free activities, please pay attention to the safety of personal property and property!",
      },
      {
        subHeader: "DAY 2",
        header: "Panda Base",
        img: panda,
        description:
          "Visit [panda base] (excluding battery car 30 yuan) is an ordinary concave shaped eastern Sichuan three courtyard. Triheyuan layout is a single eaves hanging mountain roof, wooden structure building, covers an area of 833.4 square meters, including construction area of 620 square meters, a total of size house 17, deng xiaoping's former residence is not only the great man deng xiaoping, but also the education of socialism with Chinese characteristics, patriotism education and important base of revolutionary tradition education",
      },
      {
        subHeader: "DAY 3",
        header: "Dujiangyan",
        img: dujiangyan,
        description:
          "Visit [dujiangyan] (excluding dujiangyan escalator 40 + dujiangyan battery car 30) has important cultural and historical value, two king temple as the ancient water conservancy famous li bing father and son worship temple, is an important part of the world cultural heritage of dujiangyan, after 2200 years of development and improvement, is still in use, is an outstanding representative of the ancient Chinese water conservancy project",
      },
      {
        subHeader: "DAY 4",
        header: "Chongqing",
        img: chongqingtrain,
        description:
          "[Liziba light rail through the building] about 20 minutes to take photos, a photo of the light rail shocked foreign countries, instantly brush the circle of friends, while through the dense forest, while from your head, sometimes and the river to a close contact, that section is the subway is the light rail who divided the clear. In short, I am a light rail I capricious; flying wall everything",
      },
      {
        subHeader: "DAY 5",
        header: "Chongqing",
        img: difeng,
        description:
          "Tour [natural three bridge] (excluding export storage battery 15 yuan / person, tour time about 2 hours), is the rare geological wonders ecological tourist area, belongs to the typical card landform, scenic area with dragon bridge, tsing lung bridge, black dragon bridge three majestic stone arch bridge, is an Asian natural bridge group, geological wonders of ecological tourist area, transformers 4 and city of the golden flower movie location",
      },
      {
        subHeader: "DAY 6",
        header: "Chongqing",
        img: wulong,
        description:
          'Tour [Xiannshan National Forest Park] (excluding 25 yuan / person) is one of the top ten tourist attractions in Chongqing, which is located in Wulong County, Chongqing, and is a tourist attraction integrating vacation, leisure and sports. The average altitude of the scenic spot is 1,900 meters, and the highest peak is 2,033 meters. The rare forest and snow landscape in the south is known as "the Oriental Switzerland".',
      },
      {
        subHeader: "DAY 7",
        header: "Return Trip",
        img: airport,
        description:
          "After breakfast, free activities. Then according to the return traffic time arrangement, return to the departure point, end the happy trip to Chengdu and Chongqing!",
      },
    ],
  },
  beijing: {
    headerImg: beijing,
    headerLine: "Enjoy Beijing and Tianjin",
    days: [
      {
        subHeader: "DAY 1",
        header: "Beijing",
        img: airport,
        description: "Fly to Beijing Daxing Airport and then transfer by bus to the hotel to check in",
      },
      {
        subHeader: "DAY 2",
        header: "Tian'anmen Square, Palace Museum-Nanluogu Lane-quintessence of Chinese acrobatic performance",
        img: tiananmen,
        description:
          'Since September 2015, the Palace Museum has opened four new areas to the city, including Baoyun Building, Cining Palace, Meridian Gate-Yanwing Building and Donghua Gate. The open area has increased from the current 52% to 65%. As the first of the "five major palaces in the world", the Forbidden City has not only magnificent palace buildings such as the Hall of Supreme Harmony and the Qianlong Palace, but also nearly 10,000 national first-class cultural relics. Please follow us to stroll on the wall of the Forbidden City, which has not been opened for more than 90 years, step into the towering southeast turret, go into the Cining Palace where the Empress Dowager lives in Princess Huanzhu, and the Shoukang Palace where the Empress lives in the Legend of Zhen Huan, and start a 3-hour tour of the Forbidden City.',
      },
      {
        subHeader: "DAY 3",
        header: "Badaling Great Wall, Bird's Nest / Water Cube-Capital Seine River web celebrity punch in",
        img: greatwall,
        description:
          "The Badaling Great Wall is the pride of the most Chinese people in the world, magnificent, stretching for thousands of miles, impregnable, majestic, this Oriental dragon from the Western Zhou Dynasty, across the Qin and Han Dynasties, from the Sui and Tang Dynasties, to the Ming and Qing Dynasties, after two thousand years, more than ten thousand li. Picking up the steps, following the footprints of our ancestors, the majestic Great Wall tells us about the vicissitudes of history and the changes in the world. History is called one of the nine fortress in the world, is the essence of the Great Wall, in the Ming Great Wall, unique representative. This section of the Great Wall steep terrain, commanding, is an important military pass in the Ming Dynasty and an important barrier for the capital Beijing. Badaling Scenic spot is a demonstration site of national civilized scenic tourist area. It is famous for its magnificent landscape, perfect facilities and profound cultural and historical connotation. It is a world-famous tourist resort.",
      },
      {
        subHeader: "DAY 4",
        header: "Gong Wang fu, rickshaw tour-Shichahai Hutong, Imperial College",
        img: gongwangfu,
        description:
          'Visit [Gong palace] the qing dynasty largest palace complex. It is located in the beautiful scenery of Shichahai, a quiet and long, green willow shade streets, gong Gong mansion grand scale, after the qing Dynasty from the heyday to the decline of the historical process, carrying extremely rich historical and cultural information, has "a Gong Wang palace half of the history of the Qing Dynasty". A "small" palace, but it is a microcosm of the historical changes of the Qing Dynasty. Every brick and every tile, every tree and grass has its story. One scene at a time is really a different experience.',
      },
      {
        subHeader: "DAY 5",
        header: "Porcelain House Museum Tianjin Hometown-Ancient Culture Street",
        img: tianjin,
        description:
          'Visit the priceless Art Palace- [Porcelain House Museum-Visit time 1 hour] is a French house built with ancient porcelain. The porcelain house has four stories, from the inside to the outside, except for the ground with marble paved, with porcelain tiles, and even the walls are paintings made of porcelain tiles. It is a unique building in Tianjin, its predecessor is the old French foreign house after a hundred years, its present life is the extremely luxurious "porcelain beauty building qi" the building is known as: a priceless "Chinese ancient porcelain museum". Visit [Hometown of Jinmen-Ancient Culture Street-Visit time 1.5 hours] Hometown of Jinmen, Tianjin Ancient Culture Street, located in Nankai District of Tianjin, is one of the landmark scenic spots in Tianjin. Walking in this walking commercial street full of historical charm, you can feel the strong Chinese, Tianjin, cultural and ancient flavor.',
      },
      {
        subHeader: "DAY 6",
        header: "Tianjin Daqiuzhuang Town",
        img: daqiuzhuang,
        description:
          'After breakfast, drive to the famous [Daqiuzhuang] in Tianjin; the town of Jinghai County, Tianjin. Daqiuzhuang town was built in 1993. Located in the southwest of the city, it covers an area of 7.2 square kilometers with a population of 30,000 (including registered population of 50,000). Have jurisdiction over Yaoshun Street, Wanquan Street, Jinmei Street, Jinhai Street 4 village committees. With industrial production as the main part, has formed a production pattern with iron and steel processing industry as the main body, machinery, chemical industry, electrical appliances and other industries as the backbone, steel processing and pipe making has become an important production base in China. The town industrial zone is listed as the national township enterprise demonstration area. Agricultural production has been mechanized. It is a new type of town developed after the reform and opening up. In 1995, it was named as "Star Xiaokang Town" by the municipal government.',
      },
      {
        subHeader: "DAY 7",
        header: "Send it to Beijing Capital Airport or Daxing Airport by plane back to the warm home",
        img: daxing,
        description:
          "After the hotel buffet breakfast, take the airport and fly back to the warm home according to the flight departure time. The End of the pleasant journey!",
      },
    ],
  },
  guilin: {
    headerImg: guilin,
    headerLine: "Taste the poetic landscape, explore the mystery of karst, visit the Zhuang Xiang customs",
    days: [
      {
        subHeader: "DAY 1",
        header: "Elephant Trunk Peak, Seven Star Cave",
        img: airport,
        description:
          "The banks of the Li River in downtown Guilin, made of limestone deposited from the seabed about 360 million years ago, are famous for its shape resembling an elephant drinking water along the Li River. Elephant landscape moon is the most representative of the landscape of Guilin. It is not only the uncanny work of nature, but also contains the aesthetic taste and style of traditional Chinese culture. Together with the osmanthus pattern, it forms the city emblem of Guilin.",
      },
      {
        subHeader: "DAY 2",
        header: "GuDong waterfall, Qianjing Village, Dawei ancient town, East and west lane",
        img: gudong,
        description:
          'Visit the [Gudong Waterfall] scenic area, where CCTV reported that "This is a touchable waterfall". It is a characteristic scenic spot that integrates ecological tourism and experience tourism into the natural landscape. It is also the original natural oxygen bar. Flying spray, jingling streams, rugged cliffs, green ancient trees and myriad weather. If you like, you can also enjoy the new feeling brought by "walking the waterfall and the waves".',
      },
      {
        subHeader: "DAY 3",
        header: "Longji Terrace (Ancient Zhuang Village) Morning,",
        img: longji,
        description:
          "Guzhuang Village is the oldest ancient village in the area of Longji Terraces. It includes Liaojia, Houjia, Panjia and other Zhuang villages. It is a typical representative of Zhuang (Bai Zhuang) in northern Guangxi and the birthplace of Zhuang Terraces.",
      },
      {
        subHeader: "DAY 4",
        header: "Lijiang River, Yulong River, West Street, Impression Liu Sanjie",
        img: liusanjie,
        description:
          'Lijiang River is one of the most beautiful rivers in the world, known as "Li Li River, Li Li Gallery". The two sides of the strange peaks, cliffs, hanging rivers, green mountains, green water meandering, during the boat tour, it seems to enjoy a slowly unfolding Chinese landscape painting long scroll, beautiful',
      },
      {
        subHeader: "DAY 5",
        header: "Jingjiang palace, End of the trip, send the group.",
        img: jingjiang,
        description:
          "Located in the center of Guilin city, it is composed of Ming Jingjiang Palace and Du Xiufeng, and is a national key cultural relics protection unit.",
      },
    ],
  },
  xian: {
    headerImg: xian,
    headerLine: "Zhengzhou entered Xi'an for 6 days",
    days: [
      {
        subHeader: "DAY 1",
        header: "Flight to Zhengzhou-Kaifeng Gong Temple-Ancient City Wall-Little Song City-Zhengzhou",
        img: airport,
        description:
          "Take a flight to [Zhengzhou] after arriving at the designated time, take a tour bus to [Kaifeng] (about 1.5 hours away) to visit [Bao Gong Temple] (about 40 minutes) to commemorate the famous ancient honest official and political reformer Bao Zheng, bao Zheng. He was a famous honest official and political reformer in the Northern Song Dynasty. Life to worry about the country and the people, upright.",
      },
      {
        subHeader: "DAY 2",
        header: "Zhengzhou-Dengfeng Shaolin Temple-Luoyang White Horse Temple-Luoyang",
        img: shaolin,
        description:
          'After breakfast in the hotel, go to [Dengfeng] to visit the birthplace of Chinese Buddhism "Zen" and "martial arts" [Shaolin Temple] As the ancestral court of Chinese Zen Buddhism, Shaolin Temple is located in Shaowu Mountain, west of Dengfeng, Henan Province. In the Southern and Northern Dynasties, Ba Tuo, a monk from Tianzhu, went to China to show good Zen methods and received the courtesy of Emperor Xiaowen of the Northern Wei Dynasty. In the 20th year of Taihe (496), he was Mountain to provide food and clothing. Temple in the mountain forest, so the name Shaolin. At present, there are ancient buildings such as mountain gate, guest hall, Dharma pavilion, white dress hall, Dizang hall and hall of Thousand Buddha. In the temple of the Ming Dynasty five hundred Luo Han dynasty Pilu murals.',
      },
      {
        subHeader: "DAY 3",
        header: "Luoyang-Longmen Grottoes-Lijing Gate-Huashan Mountain",
        img: luoyang,
        description:
          'Hotel after breakfast, the car to [Luoyang] to visit China\'s four major grottoes, famous for grottoes art, by the United Nations educational, scientific and cultural organization as "world cultural heritage" [longmen grottoes] (visit time about 2 hours) dug in the northern Xiaowen emperor years, after the eastern wei, western wei, north qi, sui, tang, five dynasties, song dynasty large-scale construction for more than 400 years, north and south for 1 km, today exist grottoes 2345, more than 100000 statue, inscriptions more than 2800 products. Among them, "Longmen Twenty Products" is the essence of calligraphy Wei tablet, and the "Yique Buddhist niche tablet" written by Chu Suiliang is the model of regular script art in the early Tang Dynasty. Longmen Grottoes lasted for a long time and anned many dynasties. With a large number of physical images and written materials, it reflected the development and changes of ancient Chinese fields such as politics, economy, religion, and culture from different aspects, and made great contributions to the innovation and development of Chinese grotto art.',
      },
      {
        subHeader: "DAY 4",
        header: "Huashan",
        img: huashan,
        description:
          'After breakfast, the hotel set out to visit the "strange, dangerous, steep, unique, secluded" and famous in the world, known as "the most dangerous mountain in the world" known as the West Mountain [Huashan] (tour about 5 hours) its danger is the first of the five mountains, there is a saying "Huashan is a road since ancient times". Visit the martial arts master: Jin Yong Huashan sword place, Canglong Ridge, wipe the ear cliff, kite turn over, Laojun alchemy place, Huashan chess game, golden lock pass. The scenery of Huashan is magical and changeable in four seasons. In different seasons, you can enjoy "Yunhua Mountain", "Yuhua Mountain", "Huashan Mountain" and "Snow Mountain".',
      },
      {
        subHeader: "DAY 5",
        header: "Huashan - Terracotta Warriors and horses of Qin Shihuang - Xi'an",
        img: qinshihuang,
        description:
          "Set out to [Lintong] to visit the [Terracotta Warriors and Horses of Qin Shihuang, known as the eighth wonder of the world] (visit about 3 hours) Comprehensive understanding of the qin culture and the superb technology of making terracotta figures. The Museum of Terracotta Warriors and Horses is the burial pit of the Mausoleum of Emperor Qin Shihuang. You will follow the explanation and gradually enter into deeply contact with this mighty and mysterious army. Stop the largest pit face the first emperor of thousands of troops. In the second pit, you can closely observe the display of the Qin terracotta warriors, while in the smallest third pit, you can understand the layout of the Qin army array.distinguished guests can also go to the exhibition hall to see all kinds of bronzes of the Qin Dynasty. While listening to the explanation, the magnificent Great Qin Empire in my mind (Warm reminder: the shopping shop in the Terracotta Warriors Museum is run by the museum, not organized by our club. If you need to shop, please pay careful attention)",
      },
      {
        subHeader: "DAY 6",
        header:
          "Qinglong Temple-Ming City Wall-Bell and Drum Tower Square & Hui Min Street-Xi'an Airport, flight return",
        img: qinglongsi,
        description:
          'After enjoying breakfast, the hotel will take a tour bus to visit the [Qinglong Temple], also known as the Stone Buddha Temple, which is located in the high terrain and elegant scenery. At its peak in the middle of the Tang Dynasty, there were many foreign monks studying here, especially the Japanese monks. Six of the famous "eight masters into the Tang Dynasty": Japan\'s empty sea, Yuan Xing, Yuan Ren, Huiyuan, Yuan Zhen, and Zong Rui are all subject to this law. In particular, Konghai (also known as Master Hongfa) worship Mitzong Master Huiguo as a teacher, learning the true meaning of Mitzong after returning to Japan to establish the Zhenzong, become the founder of the "Dongmi" patriarch. Therefore, Qinglong Temple is the sacred temple in the eyes of the Japanese, and the ancestral court of the Japanese Buddhism. Qinglong Temple introduced more than 1,000 cherry trees from Japan, planted in the temple. Every year in March and April, the cherry blossoms are in full bloom, and the spring scenery is full of colorful flowers and abnormal scenery. Up to now, Qinglong Temple has attracted many tourists from home and abroad with its legendary historical role and beautiful quiet scenery.(There are climate differences between the north and the south. If the cherry blossoms cannot be seen due to climate reasons, we will not make any compensation.)',
      },
    ],
  },
  suzhou: {
    headerImg: suzhou,
    headerLine:
      "[Meet Jiangnan] into the paradise, under the historical and cultural city Leading the new retail era of Suzhou and Hangzhou",
    days: [
      {
        subHeader: "DAY 1",
        header: "Flying to Shanghai",
        img: airport,
        description:
          "The Bund is the starting point of modern Shanghai city, but also includes the essence of the whole city. Since the opening of Shanghai port (trade) in 1843, it has become the most prosperous area in the whole city, even today. Along the wide Huangpu River, the century-old buildings of the Bund and the new city of Lujiazui on the other side complement each other, showing the past and prosperity of Shanghai in a blink of an eye.",
      },
      {
        subHeader: "DAY 2",
        header: "Shanghai",
        img: shanghai2,
        description:
          "Welcome to an unprecedented magical world to light up your dream here. This is Shanghai Disneyland, both old and young, you can feel the fun full of creativity, adventure and excitement here! Look at fantasy Castle, the world's largest Disney castle, ready to explore these seven fascinating and memorable parks: Mickey Street, Fantasy Garden, Fantasy World, Adventure Island, Treasure Bay, Tomorrowland and Disney Pixar Toy Story Park;",
      },
      {
        subHeader: "DAY 3",
        header: "Shanghai - Suzhou",
        img: suzhouCity,
        description:
          '[World Cultural Heritage ● Garden] (tour time is not less than 1.5 hours) set the south of the Yangtze garden, residence, ancestral temple, nunnery, garden in one, and is good at the architectural structure. The courtyard is deep and elegant interest of traditional culture, the strange rocks, the pool is green, and has the reputation of "not out of the city or the interest of the forest". The whole garden is mainly divided into four parts: east, middle, west and north, with different scenery. Therefore, in a garden, people can enjoy the four customs of landscape, pastoral, mountain forest and garden, which can be called the model of the artistic treatment of architectural space in the world.',
      },
      {
        subHeader: "DAY 4",
        header: "Suzhou - Nanjing",
        img: nanjing,
        description:
          "[Meiling Palace], built in 1931, built by the then Nanjing government, cost 360,000 silver yuan, covers an area of nearly 100 mu, the building is elegant and spectacular, the air looks like the pearl and diamond chain, this is Chiang Kai-shek, Soong Meiling personally site, creatively built a mansion.",
      },
      {
        subHeader: "DAY 5",
        header: "Nanjing - Hangzhou",
        img: hangzhou,
        description:
          "Enjoy the spring dawn, willow waves, three pools, etc.; Su Causeway walk, flower harbor fish, red fish pond, peacock garden, Kangxi royal monument; Su Dongpo Memorial Hall; Tips: weekends and holidays, other vehicles are prohibited to enter the West Lake scenic area, need to walk or transfer to the bus (this cost) into the scenic area, please understand the inconvenience caused!",
      },
      {
        subHeader: "DAY 6",
        header: "Hangzhou - Wuzhen",
        img: wuzhen,
        description:
          'Participate in the special experience specially arranged by our club —— [lights walk the bridge]. It is a custom that has been spread for many years in China, which contains the good meaning of "peace and auspiciousness". Under the cover of night, through the bridge and water, reach the happy family, trigger good wishes with actions, and describe the journey of the water town with warmth.',
      },
    ],
  },
  xiamen: {
    headerImg: xiamen,
    headerLine: "A tale of two cities on the sea silk: a trip to Xiamen & Quanzhou - 5-day study tour in Xiamen",
    days: [
      {
        subHeader: "DAY 1",
        header: "Intangible cultural heritage skills Hui'an shadow sculpture",
        img: airport,
        description: "Set out for the beautiful Xiamen, pick up the airport.",
      },
      {
        subHeader: "DAY 2",
        header: "Enjoy the great scenery of Xiamen The mansion big dream",
        img: xiamenU,
        description:
          "(One of the three campuses of Xiamen University Siming Campus / Xiang'an Campus / Zhangzhou Campus will be arranged according to the specific situation of the university). If you cannot enter due to special circumstances, it will be adjusted to Huaqiao University or other locations) Visit the campus of Xiamen University.",
      },
      {
        subHeader: "DAY 3",
        header: "Spring mansion elegance Research way time",
        img: quanzhouwulin,
        description:
          "Arrive in Wulin ancient villages, stroll the villages, enjoy the Minnan official houses, Fanzai Lou, houses and other buildings, feel the blend of southern Fujian and Nanyang culture; visit the overseas Chinese museum, understand the story of overseas Chinese struggle and love the homeland.",
      },
      {
        subHeader: "DAY 4",
        header: "Gulangyu",
        img: gulangyu,
        description:
          "Enjoy the beauty of the architecture of Gulangyu Island: along the international architecture expo line [British and Japanese Consulate], [Catholic Church], [Yellow Huang Hall] and other architectural characteristics; visit [Historical Exhibition Hall], explore and innovate the mechanism of cultural heritage protection and inheritance along the direction guided by General Secretary Xi",
      },
      {
        subHeader: "DAY 5",
        header: "Visit Jimei School Village",
        img: jimeiU,
        description:
          "Tan Kah Kee Memorial Hall, Tan Kah Kee former residence, Ao Yuan, listen to the stories in the Ao Yuan, and experience the lofty spirit of Mr.Tan Kah Kee.",
      },
    ],
  },
  changsha: {
    headerImg: changsha,
    headerLine: "Explore Changsha and feel the beauty of history and culture",
    days: [
      {
        subHeader: "DAY 1",
        header: "Set out for Zhangjiajie",
        img: airport,
        description: "",
      },
      {
        subHeader: "DAY 2",
        header: "Geological tracing and folk custom experience",
        img: zhangjiajie2,
        description:
          "Zhangjiajie, hidden in the magnificent embrace of Hunan Wuling Mountains, towering peaks, clouds and mist, as if a fairyland lost on the world, hundreds of million years of geological wonders, telling the uncanny workmanship of nature. Stone peaks such as sword, straight stab the sky, as if the most resolute brush between heaven and earth, outline a magnificent picture; Zhangjiajie National Forest Park, every mountain is the silent poem of nature, they experienced the vicissitudes of life, with silent and majestic posture, to show visitors the depth and mystery of the history of the earth.",
      },
      {
        subHeader: "DAY 3",
        header: "Explore the hole for knowledge Ancient street pick up fun",
        img: huanglongcave,
        description:
          "Huanglong Cave in Zhangjiajie is located in Suoxiyu Town, Wulingyuan District, Zhangjiajie City, Zhangjiajie, Hunan Province. It is an important part of the World Natural Heritage and world Geopark Wulingyuan. Huanglong Cave has a total length of 7.5 kilometers and a vertical height of 140 meters. A complete karst cave system is developed inside the cave, including stalactite, stone mantle, underground river and other typical geomorphic forms.",
      },
      {
        subHeader: "DAY 4",
        header: "One thousand years of context pass down from generation to generation",
        img: hunanU,
        description:
          "In the center of the city, there is an ancient and mysterious street —— Taiping Street, it is like a living history of Changsha, witnessed the rise and fall of the city; Yuelu Academy, hidden in the west bank of the Xiangjiang River valley, ancient trees, scholarly sleeves, is a millennium of learning, string song. Hunan University, echoing the echoes of history, feels the depth of culture; Hunan University, shining on the intelligent sky, like a thick history, resting on the combination of bricks and light, slowly out the cultural treasures and vicissitudes of the land of Hunan.",
      },
      {
        subHeader: "DAY 5",
        header: "The great man's hometown Red inheritance",
        img: shaoshan,
        description:
          "We are about to embark on a meaningful journey into —— Shaoshan, the hometown of Chairman MAO, to explore the magnificent life of this great leader. Shaoshan, the land that gave birth to great leaders, not only carries profound historical deposits, but also contains endless red spirit. Here, we will visit important scenic spots such as Mao Zedong's Bronze statue Square, his former residence and Mao Zedong Memorial Hall, gradually uncover the mystery of Chairman Mao Zedong's growth process, and deeply understand the formation of his thoughts and his far-reaching influence on China's revolution and construction.",
      },
      {
        subHeader: "DAY 6",
        header: "Truly great men Heaven's Retribution",
        img: juzizhoutou,
        description:
          'Orange island, a bright pearl in the Xiangjiang River, the island of trees, four seasons of flowers, the Xiangjiang River on the beautiful scenery, landscape set each other off. More than 100 years ago, MAO Zedong, in the prime of life, it was in this vibrant land, wrote the magnificent "Qinyuan Spring · Changsha", expressing his deep feelings for the fate of the country and his lofty aspirations to take the world as his own responsibility. The cry of "ask the vast land, who is the main ups and downs", like the deafening horn, has awakened the revolutionary fighting spirit of countless people with lofty ideals.',
      },
    ],
  },
};
